var _title, _path, _path2;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconUserNew = function SvgIconUserNew(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "icon-user-new")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 1.328c-1.984 0.656-3.92 2.416-4.912 4.432-0.896 1.84-1.152 2.976-1.152 5.28-0.016 1.648 0.048 2.208 0.368 3.2 1.552 5.024 5.648 7.696 9.824 6.4 2.752-0.848 4.912-3.328 5.824-6.72 0.384-1.408 0.368-4.48-0.016-5.92-0.752-2.784-2.608-5.184-4.816-6.256-1.024-0.48-1.264-0.528-2.8-0.576-1.072-0.032-1.904 0.032-2.32 0.16z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.808 20.416c-3.584 0.864-6.208 4.080-6.208 7.616 0 1.36 0.384 2.16 1.28 2.672 0.608 0.336 0.672 0.336 13.232 0.336h12.64l0.544-0.368c0.944-0.64 1.264-1.28 1.264-2.592 0-3.824-2.896-7.12-6.832-7.792-1.376-0.224-1.952-0.080-2.256 0.56-0.944 1.968-6.208 2.72-9.040 1.28-1.056-0.528-1.712-1.024-1.712-1.264 0-0.352-0.688-0.704-1.36-0.688-0.352 0-1.056 0.112-1.552 0.24z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconUserNew, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-user-new.4aef0a40.svg";
export { ForwardRef as ReactComponent };